/**
 * API Configuration
 * Centralizes the base URL for all clinical backend services.
 */

export const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost/vision/api';

export const ENDPOINTS = {
  REMINDER: `${API_BASE}/follow_up.php`,
  // Add future endpoints here
};
